import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Divider,
  Grid,
  FormControlLabel,
  Checkbox,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  createPlanRequest,
  fetchPlansRequest,
  updatePlanRequest,
} from "../../../redux/sagas/Subscription/SubscriptionSlice";
import CustomModal from "../../Comman/Modal";
import { toast } from "react-toastify";
import TableCompo from "../Table/TableCompo";
import { RiDeleteBin6Line, RiEdit2Fill } from "react-icons/ri";
import CouponModal from "./Coupon";
import {
  deleteCouponRequest,
  fetchCouponsRequest,
} from "../../../redux/sagas/Coupon/CouponSlice";
import dayjs from "dayjs";
import { ViewAgendaOutlined } from "@mui/icons-material";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import useCsvConverter from "../../../hooks/convertToCSV";
import { canShowPermission } from "../Permissions/permissionObject";

const CouponList = () => {
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [update, setUpdate] = useState(false);
  const [statusConfirmDialogOpen, setStatusConfirmDialogOpen] = useState(false);
  const [deleteCoupon, setDeleteCoupon] = useState(null);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(selectedRow);
    if (selectedRow) {
      setUpdate(true);
    }
  }, [selectedRow]);

  useEffect(() => {
    console.log(update);
  }, [update]);

  const { data = [] ,total = 0 } = useSelector((state) => state.coupon || {});
  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateCoupon = canShowPermission(
    permissions,
    "couponlist",
    "create",
  );
  const canEditCoupon = canShowPermission(permissions, "couponlist", "edit");

  const columns = [
    {
      field: "targetType",
      headerName: "Target",
      render: (value, row) => {
        return value.toUpperCase();
      },
    },
    { field: "code", headerName: "Coupon Code" },
    { field: "couponType", headerName: "Coupon Type" },
    {
      field: "expiry",
      headerName: "Validity",
      render: (value) => {
        if (!value) return "-";
        return dayjs(value).format("DD-MM-YYYY hh:mm A");
      },
    },
    { field: "value", headerName: "Amount" },
    // { field: 'scheduleAt', headerName: 'Schedule At',  render: (value, row) => (
    //     <>{moment(row.scheduleAt).format("DD-MM-YYYY hh:mm A")}</>
    //   ) },
    // { field: 'noti', headerName: 'Notification Sent',  render: (value, row) => (
    //    <>{row.isNotificationSent ? "Yes" : "No"}</>
    //   ) },
    {
      field: "action",
      headerName: "Action",
      render: (value, row) => (
        <Box>
          {canEditCoupon && (
            <RiEdit2Fill
              style={{ cursor: "pointer", color: "green", marginRight: 10 }}
              onClick={() => {
                setSelectedRow(row);
                setOpen(true);
              }}
            />
          )}
          {canEditCoupon && (
            <RiDeleteBin6Line
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => {
                setDeleteCoupon(row);
                setStatusConfirmDialogOpen(true);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "createdBY",
      headerName: "Created By",
      width: 200,
      hideInExcel: true,
      render: (value, row) => {
        return row?.createdBy ? row.createdBy.name : "N/A";
      },
    },
    {
      field: "updatedBy",
      headerName: "Updated By",
      width: 200,
      hideInExcel: true,
      render: (value, row) => {
        return row?.updatedBy ? row.updatedBy.name : "N/A";
      },
    },
  ];
  useEffect(() => {
    dispatch(
      fetchCouponsRequest({ page: page + 1, limit: limit, search: searchText }),
    );
    console.log("coupon datta", data);
  }, [dispatch, page, limit, searchText]);
  const handleDelete = (row) => {
    setStatusConfirmDialogOpen(true);
    dispatch(deleteCouponRequest(row._id));
  };

  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadStoreCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/coupon/couponsCsv",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "coupon.csv");
        },
      }),
    );
  };
  const handleTableChange = (action, payload) => {
    if (action === "changePage") {
      setPage(payload.page);
    }

    if (action === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }

    if (action === "search") {
      setSearchText(payload.searchText);
      setPage(0);
    }
  };
 const safeData = Array.isArray(data) ? data : [];

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {/* Status Confirmation Dialog */}
      <Dialog
        open={statusConfirmDialogOpen}
        onClose={() => setStatusConfirmDialogOpen(false)}
      >
        <DialogTitle>Delete Coupon</DialogTitle>
        <DialogContent>
          <Typography>Do you want to delete this coupon?</Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2,
            }}
          >
            <button
              style={{
                padding: "6px 12px",
                backgroundColor: "#4caf50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch(dispatch(deleteCouponRequest(deleteCoupon._id)));
                setStatusConfirmDialogOpen(false);
              }}
            >
              Yes
            </button>
            <button
              style={{
                padding: "6px 12px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                setStatusConfirmDialogOpen(false);
              }}
            >
              No
            </button>
          </Box>
        </DialogContent>
      </Dialog>
      <Box sx={{ height: "100%", overflowY: "auto", p: 2 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            mx: "auto",
            mt: 0,
            background: "#fff",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            p: { xs: 2, md: 4 },
          }}
        >
          <Typography fontWeight={700} fontSize={24} mb={2} fontFamily="Aeonik">
            Coupon List
          </Typography>
          {canCreateCoupon && (
            <Button variant="contained" onClick={() => setOpen(true)}>
              Create Coupon
            </Button>
          )}
          <CouponModal
            open={open}
            onClose={() => {
              setOpen(false);
              setSelectedRow(null);
            }}
            onSubmit={(data) => console.log(data)}
            initialData={selectedRow}
          />

          <TableCompo
            columns={columns}
            data={safeData}
            page={page}
            limit={limit}
            totalCount={total}
            onTableChange={handleTableChange}
            extraButtons={
              <Button
                size="sm"
                variant="outlined"
                onClick={handleDownloadStoreCsv}
              >
                Download CSV
              </Button>
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CouponList;
